import React, { useEffect, useState } from 'react'
import AppSidebar from '../../../components/AppSidebar'
import AppHeader from '../../../components/AppHeader'
import PageHeader from '../../../components/PageHeader'
import { currencyOptions } from '../../../utils/OptionUtils'
import DocumentForm from '../../../components/DocumentForm'
import TagsInput from '../../../components/TagsInput'
import CustomersService from '../../../services/CustomersService'
import { toast, ToastContainer } from 'react-toastify'
import SelectTag from "../../../components/SelectTag";
import { useForm } from 'react-hook-form'
import { discountTypeOptions } from '../../../../src/utils/OptionUtils';
import UsersService from '../../../services/UsersService'
import { recurringOptions } from '../../../../src/utils/OptionUtils';


const CreateInvoice = () => {
    const { control } = useForm();
    const [isInfinite, setIsInfinite] = useState(false);
    const [tags, setTags] = useState([]);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [userOptions, setUserOptions] = useState([]);
    const handleCheckboxChange = (e) => {
        setIsInfinite((prev) => !prev);
    };
    const fetchCustomersList = async () => {
        try {
            const response = await CustomersService.listAll();
            if (response.status === 200) {
                setCustomerOptions(response?.data?.data?.map((item) => ({
                    label: item.company,
                    value: item.id,
                })));
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    }
    const fetchUsersList = async () => {
        try {
            const response = await UsersService.list();
            if (response.status === 200) {
                setUserOptions(response?.data?.data?.map((item) => ({
                    label: item.name + " (" + item.email + ")",
                    value: item.id,
                })));
            }
        } catch (error) {
            toast.error(error?.message || "An error occurred");
        }
    }
    useEffect(() => {
        fetchCustomersList();
        fetchUsersList();
    }, []);
    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <PageHeader title="Create Invoice" className="btn btn-sm btn-primary" link_to="/invoices" button_label="Back" />

                    <div className="card mt-4 shadow-sm">
                        <div className="card-body">
                            <form>
                                <div className="row">
                                    {/* Left Column */}
                                    <div className="col-12 col-xl-6">
                                        <div className="mb-3">
                                            <label htmlFor="customer" className="form-label">Customer</label>
                                            <SelectTag
                                                options={customerOptions}
                                                name={"customer"}
                                                label={"Customer"}
                                                control={control}
                                            />
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="bill_to" className="form-label">Bill To</label>
                                                    <textarea className="form-control" name="bill_to" id="bill_to" rows="3"></textarea>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="ship_to" className="form-label">Ship To</label>
                                                    <textarea className="form-control" name="bill_to" id="bill_to" rows="3"></textarea>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="invoice_number" className="form-label">Invoice Number</label>
                                            <div className="input-group">
                                                <span className="input-group-text">#</span>
                                                <input type="text" className="form-control" name="invoice_number" id="invoice_number" />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="invoice_date" className="form-label">Invoice Date</label>
                                                    <input type="date" className="form-control" name="invoice_date" id="invoice_date" />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="due_date" className="form-label">Due Date</label>
                                                    <input type="date" className="form-control" name="due_date" id="due_date" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Right Column */}
                                    <div className="col-12 col-xl-6">
                                        <div className="mb-3">
                                            <label htmlFor="tags" className="form-label">Tags</label>
                                            <TagsInput tags={tags} setTags={setTags} />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="payment_modes" className="form-label">Allowed payment modes for this invoice </label>
                                            <select className="form-control form-select" name="payment_modes" id="payment_modes" defaultValue={'cash'}>
                                                <option value="">Select Payment Mode</option>
                                                <option value="cash">Cash</option>
                                                <option value="bank">Bank</option>
                                            </select>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="currency" className="form-label">Currency</label>
                                                    {/* <select className="form-control form-select" name="currency" id="currency" defaultValue={'inr'}>
                                                        <option value="">Select Currency</option>
                                                        {currencyOptions?.map((option, index) => (
                                                            <option key={index} value={option.value}>{option.label}</option>
                                                        ))}
                                                    </select> */}
                                                    <SelectTag
                                                        options={currencyOptions}
                                                        name={"currency"}
                                                        label={"Currency"}
                                                        control={control}
                                                        defaultValue={"inr"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="sales_agent" className="form-label">Sales Agent</label>
                                                    {/* <select className="form-control form-select" name="sales_agent" id="sales_agent" defaultValue={'draft'}>
                                                        <option value="">Select Status</option>
                                                        {userOptions?.map((option, index) => (
                                                            <option key={index} value={option.value}>{option.label}</option>
                                                        ))}
                                                    </select> */}
                                                    <SelectTag
                                                        options={userOptions}
                                                        name={"sales_agent"}
                                                        label={"Sales Agent"}
                                                        control={control}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="recurring" className="form-label">Recurring Invoice?</label>
                                                    <SelectTag
                                                        options={recurringOptions}
                                                        name={"recurring"}
                                                        label={"Recurring"}
                                                        control={control}
                                                        defaultValue={"no"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="mb-3">
                                                    <label htmlFor="discount_type" className="form-label">Discount Type</label>
                                                    <SelectTag
                                                        options={discountTypeOptions}
                                                        name={"discount_type"}
                                                        label={"Discount Type"}
                                                        control={control}
                                                        defaultValue={"no_discount"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="cycles" className="form-label">Total Cycles</label>
                                            <div className="input-group">
                                                <input type="text" className="form-control" name="cycles" id="cycles" defaultValue={0} disabled={isInfinite} />
                                                <div className="input-group-text">
                                                    <input type="checkbox" className="form-check-input" id="infinityCheckbox" onChange={handleCheckboxChange} checked={isInfinite} />
                                                </div>
                                                <span className="input-group-text">Infinity</span>
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="notes" className="form-label">Admin Notes</label>
                                            <textarea className="form-control" name="notes" id="notes" rows="3"></textarea>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <DocumentForm />
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default CreateInvoice